var map = {
	"./jianshiClick.png": "rV4b",
	"./shushiClick.png": "Ela+",
	"./yingrenClick.png": "JW/H",
	"./youxiaClick.png": "2plq"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "QwOu";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image ^\.\/.*Click\.png$
// module id = QwOu
// module chunks = 0